export default __webpack_public_path__ + "static/media/480_store03-fr-web.a781bbda.png";